<template>
  <svg
    :class="{ active }"
    class="marzipano-hotspot"
    viewBox="0 0 200 200"
    xml:space="preserve"
    @click.stop.prevent="handleClick"
  >
    <g transform="translate(100,100)">
      <path class="view-sector" d="M0 0-70-70A99 99 0 0 1 70-70Z"/>
      <circle
        v-tooltip="{ content: data.title, classes: 'minimap-hotspot-tooltip' }"
        class="dot"
        cx="0"
        cy="0"
        r="22"
      />
    </g>
    <defs>
        <linearGradient id="graddy" x1="0" x2="0" y1="0" y2="1">
          <stop class="stop3" offset="0%"/>
          <stop class="stop2" offset="75%"/>
          <stop class="stop1" offset="100%"/>
        </linearGradient>
      </defs>
  </svg>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'MarzipanoHotspot',
  props: {
    data: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    navigate: {
      type: Function,
      required: false,
    },
  },
  mounted() {
    const percent = prop => `${this.data[prop] * 100}%`;
    const angle = prop => `${this.data[prop]}rad`;

    [
      { from: 'x1', to: 'x', convert: percent },
      { from: 'y1', to: 'y', convert: percent },
      { from: 'rotation', to: 'angle', convert: angle },
    ]
      .forEach(({ to, from, convert }) =>
        this.$el.style.setProperty(`--${to}`, convert(from)));

    this.$root.$on('view-yaw', (radiants) => {
      if (this.active) {
        this.$el.style.setProperty('--angle', `${radiants}rad`);
      }
    });
  },
  methods: {
    ...mapActions('nativePanorama', ['resetHotspot']),
    handleClick() {
      this.navigate
        ? this.navigate(this.data)
        : this.resetHotspot(this.data.id);
    },
  },
};
</script>

<style lang="scss" scoped>
$hotspot-size: 24.4px;

.marzipano-hotspot {
  position: absolute;
  width: 100px;
  height: 100px;
  transform: translate(-50%, -50%);
  left: var(--x);
  top: var(--y);
  color: white;
  cursor: pointer;
  pointer-events: none;

  .dot {
    stroke: #FFFFFF;
    stroke-width: 5px;
    stroke-miterlimit: 10;
    outline: none;
  }

  &.active {
    .dot {
      fill: var(--primary-color);
    }

    .view-sector {
      opacity: 1;
    }
  }

  &:not(.active) {
    .dot {
      fill: rgba(0, 0, 0, 0.54);
    }

    .view-sector {
      opacity: 0;
    }
  }

  .dot {
    pointer-events: auto;
  }

  .view-sector {
    fill: url(#graddy);
    transform: rotate(var(--angle, 0));
  }

  .stop1 {
    stop-color: currentColor;
    stop-opacity: 1
  }

  .stop2 {
    stop-color: currentColor;
    stop-opacity: 0.75;
  }

  .stop3 {
    stop-color: currentColor;
    stop-opacity: 0;
  }
}
</style>

<style lang="scss">
.minimap-hotspot-tooltip {
  background: white;
  border-radius: 4px;
  padding: 0 5px;
  margin-bottom: 7px;
  font-size: calc(1em - 1px);
}
</style>
